import React, { useState } from 'react';
import '../../styles/InputField.css';

type InputFieldProps = {
  text?: string;
  fontSize?: string;
  fontWeight?: number | string;
  lineHeight?: string;
  width?: string;
  color?: string;
  type?: 'text' | 'password';
  style?: React.CSSProperties;
  disabled?: boolean;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  error?: boolean;
};

const InputField: React.FC<InputFieldProps> = ({
  text = '',
  fontSize = '16px',
  fontWeight = 400,
  lineHeight = '20px',
  width,
  color = '#222222',
  type = 'text',
  style = {},
  value,
  disabled,
  onChange,
  onKeyDown,
  error = false,
}) => {
  const [focused, setFocused] = useState(false);

  const customStyles: React.CSSProperties = {
    fontSize,
    fontWeight,
    lineHeight,
    width,
    color,
    ...style,
  };

  const inputClass = `input-field ${focused ? 'focused' : ''} ${error ? 'error' : ''}`;

  return (
    <input
      className={inputClass}
      placeholder={text}
      style={customStyles}
      type={type}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      disabled={disabled}
    />
  );
};

export default InputField;
